module.exports = __webpack_public_path__ + "static/media/bg_top.94ae6214.png";